import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const ChoosePlan = lazy(() => import("@/pages/ChoosePlan"));

export const Route = createFileRoute("/choose-plan")({
  component: ChoosePlan,
});
